import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import moment from "moment"; // Import moment for date formatting
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineArrowBack } from "react-icons/md";
import Select from "react-select";

import { useTranslation } from "react-i18next";
import { API_CREATE_COUPEN } from "api/coupen-management";
import { API_UPDATE_COUPEN } from "api/coupen-management";
import { useLocation, useNavigate } from "react-router-dom";
import { API_LIST_PLAN } from "api/plan-management";

const EditCoupon = () => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const location = useLocation();
  const Navigate = useNavigate();
  const [datas, setDatas] = useState();
  const [selectedOptionPlans, setSelectedOptionPlans] = useState();

  const handleOptionChangePlans = (selectedOptions) => {
    setSelectedOptionPlans(selectedOptions);
  };
  const data = location.state && location.state.data;

  const fetchData = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_PLAN(params);
      console.log("coupen", newData);
      setDatas(newData?.plans);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const options = datas?.map((option, index) => ({
    value: option?._id,
    label: option?.plan_type,
  }));
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const selectedItems = data?.discounted_plan_info
      ?.filter((item) => data?.discount_for_plan?.includes(item?._id)) // Filter items where _id exists in discount_for_plan
      ?.map((item) => ({
        value: item?._id,
        label: item?.plan_title,
      }));
    if (selectedItems) {
      setSelectedOptionPlans(selectedItems);
    }
  }, []);
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              coupon_title: data?.coupon_title,
              coupon_description: data?.coupon_description,
              coupon_expiry_date: moment
                .unix(data?.coupon_expiry_date)
                .toDate(),
              // coupon_start_date: moment.unix(data?.coupon_start_date),
              coupon_start_date: moment.unix(data?.coupon_start_date).toDate(),

              coupon_type: data?.coupon_type,
              coupon_discount: data?.coupon_discount,
              discount_for_plan: data?.discount_for_plan,
            }}
            validationSchema={Yup.object({
              // Add validation rules for the coupon-related fields
              coupon_title: Yup.string()
                .required("Required")
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              coupon_description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              coupon_expiry_date: Yup.string().required("Required"),
              coupon_start_date: Yup.string().required("Required"),
              coupon_type: Yup.string()
                .required("Required")
                .oneOf(
                  ["fixed", "percentage"],
                  "Must be 'fixed' or 'percentage'"
                ),
              coupon_discount: Yup.number().required("Required"),
              // discount_for_plan: Yup.array().min(1, "Select at least one plan"),
              // discount_for_plan: Yup.string().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   // Extract coupon-related values
              //   const payload = {
              //     ...values,
              //     discount_for_plan: [values?.discount_for_plan],

              //     coupon_expiry_date: moment(values.coupon_expiry_date).unix(),
              //     coupon_start_date: moment(values.coupon_start_date).unix(),
              //   };
              //   const userData = await API_UPDATE_COUPEN(payload, data?._id);
              //   Navigate("/admin/main-coupon-management/coupon-tables");

              //   toast.success(userData?.message);
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                {/* Include input fields for all the provided coupon-related fields */}
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>Back</p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <div className="mb-3 ">
                      <label className="font-semibold">
                        {t("Title")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="coupon_title"
                        placeholder={t("Coupon Title")}
                        maxLength={20}
                        onKeyPress={(event) => {const charCode = event.charCode;
                          if (!(charCode >= 65 && charCode <= 90) && !(charCode >= 97 && charCode <= 122) && charCode !== 32) {event.preventDefault();}}}/>
                      <ErrorMessage
                        name="coupon_title"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={6}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Start Date")} <span className="text-[red]">*</span>
                      </label>
                      <DatePicker
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        selected={values.coupon_start_date} // Use `selected` prop instead of `value`
                        onChange={(date) => setFieldValue("coupon_start_date", date)}
                        dateFormat="yyyy-MM-dd"
                        placeholderText={t("Coupon Start Date")}
                        minDate={new Date()}/>
                      <ErrorMessage
                        name="coupon_start_date"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Expiry Date")} <span className="text-[red]">*</span>
                      </label>
                      <DatePicker
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        selected={values.coupon_expiry_date} // Use `selected` prop instead of `value`
                        onChange={(date) =>
                          setFieldValue("coupon_expiry_date", date)
                        }
                        minDate={values?.coupon_start_date} // Set the minDate prop
                        disabled={!values?.coupon_start_date}
                        dateFormat="yyyy-MM-dd" // Set your desired date format
                        placeholderText={t("Coupon Expiry Date")}
                      />
                      <ErrorMessage
                        name="coupon_expiry_date"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Type")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as="select" // Render as a select box
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="coupon_type"
                      >
                        <option value="percentage">Percentage</option>
                        <option value="fixed">Fixed</option>
                      </Field>
                      <ErrorMessage
                        name="coupon_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Discount")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="coupon_discount"
                        placeholder={
                          values?.coupon_type == "fixed"
                            ? t("Enter Amount in SAR")
                            : t("Enter Discount percentage Amount")
                        }
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="coupon_discount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Discount for Plan")}{" "}
                        <span className="text-[red]">*</span>
                      </label>
                      <Select
                        className="mt-2 flex h-11 w-full items-center  rounded-xl  border-2 border-gray-300 bg-white p-3  text-sm outline-none"
                        onChange={handleOptionChangePlans}
                        options={options}
                        isMulti
                        placeholder="Select options"
                        value={selectedOptionPlans}
                      />
                      {/* <Field
                        as="select" // Using select element
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="discount_for_plan"
                      >
                        {datas?.map((value, index) => {
                          return (
                            <option key={index} value={value?.plan_type}>
                              {value?.plan_type}
                            </option>
                          );
                        })}
                      </Field> */}
                      <ErrorMessage
                        name="discount_for_plan"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block  min-h-28   w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="coupon_description"
                        placeholder={t("Coupon Description")}
                      />
                      <ErrorMessage
                        name="coupon_description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Updating") + "..." : t("Update Coupen")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                // Extract coupon-related values
                const payload = {
                  ...valuesData,
                  // discount_for_plan: [valuesData?.discount_for_plan],
                  discount_for_plan: selectedOptionPlans?.map(
                    (plan) => plan?.value
                  ),

                  coupon_expiry_date: moment(
                    valuesData.coupon_expiry_date
                  ).unix(),
                  coupon_start_date: moment(
                    valuesData.coupon_start_date
                  ).unix(),
                };
                const userData = await API_UPDATE_COUPEN(payload, data?._id);
                Navigate("/admin/main-coupon-management/coupon-tables");

                toast.success(userData?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.error);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div className="flex items-center" style={{ flexDirection: "column" }}>
              <div>
                <p className="mb-1 font-bold">Save Changes</p>
                <p className="mb-8 font-medium">
                  Do you want to Save Changes before leaving the Page?
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  Cancel
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      // Extract coupon-related values
                      const payload = {
                        ...valuesData,
                        // discount_for_plan: [valuesData?.discount_for_plan],
                        discount_for_plan: selectedOptionPlans?.map(
                          (plan) => plan?.value
                        ),
                        coupon_expiry_date: moment(
                          valuesData.coupon_expiry_date
                        ).unix(),
                        coupon_start_date: moment(
                          valuesData.coupon_start_date
                        ).unix(),
                      };
                      const userData = await API_UPDATE_COUPEN(
                        payload,
                        data?._id
                      );
                      Navigate("/admin/main-coupon-management/coupon-tables");

                      toast.success(userData?.message);
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.error);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditCoupon;
